export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-gray-900 text-gray-300 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">VOS-SYSTEM</h3>
            <p className="text-gray-400 leading-relaxed mb-4">
              Protecting your digital privacy with advanced VPN technology. Secure, fast, and reliable internet access for everyone.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('security')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Security
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  How It Works
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-indigo-400 text-xl mt-1"></i>
                <a href="mailto:contact@vos-systemdoozabalj.com" className="text-gray-400 hover:text-white transition-colors cursor-pointer break-all">
                  contact@vos-systemdoozabalj.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-indigo-400 text-xl mt-1"></i>
                <a href="tel:+18164764929" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  +1 816-476-4929
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-indigo-400 text-xl mt-1"></i>
                <span className="text-gray-400">
                  CURUSKA 3<br />
                  Zabalj, 382140<br />
                  Serbia
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-indigo-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-indigo-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-indigo-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-indigo-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © 2024 VOS-SYSTEM DOO ZABALJ. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
